import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTransition from '../components/common/PageTransition';
import SEOHead from '../components/common/SEOHead';
import SectionHeader from '../components/common/SectionHeader';

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageTransition>
      <SEOHead title={t('legal.privacyPage.title')} />
      <div className="space-y-12">
        <SectionHeader
          title={t('legal.privacyPage.title')}
          description={t('legal.privacyPage.description')}
          iconName="Shield"
          badge={t('legal.privacyPage.badge')}
        />
        <div className="art-card p-6 md:p-8 rounded-2xl border-black/5 dark:border-white/10 space-y-6 text-slate-700 dark:text-slate-300">
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{t('legal.privacyPage.collection.title')}</h3>
            <p>{t('legal.privacyPage.collection.p1')}</p>
          </section>
          
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{t('legal.privacyPage.usage.title')}</h3>
            <p>{t('legal.privacyPage.usage.p1')}</p>
          </section>
          
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{t('legal.privacyPage.rights.title')}</h3>
            <p>
              {t('legal.privacyPage.rights.p1')}
            </p>
          </section>
        </div>
      </div>
    </PageTransition>
  );
};

export default Privacy;
